
import { Button, Checkbox, FormControl } from '@mui/material';
import autobind from 'autobind-decorator';
import debounce from 'lodash/debounce';
import Icon from '__common/components/Icon';
import React from 'react';
import RowsPerPage from '__common/components/RowsPerPage';
import { CHECK_UB1_PROJECTS, SET_MODULE, SET_PROJECT_CREATED_LOWER_RANGE, SET_PROJECT_CREATED_UPPER_RANGE, SET_PROJECT_PRICE_LOWER_RANGE, SET_PROJECT_PRICE_UPPER_RANGE, SET_PROJECT_STATE, SET_PROJECT_WATTAGE_LOWER_RANGE, SET_PROJECT_WATTAGE_UPPER_RANGE } from 'yourProjects/yourProjectsActions';
import { connect } from 'react-redux';
import { TextField } from '@mui/material';
// import { SelectionControl } from 'react-md'; // moved to mui material
import {
  FILTER_BY_STRING,
  GET_USER_PROJECTS,
  SET_ROWS_PER_PAGE,
  SET_YOUR_PROJECTS_PAGINATION_START,
  SET_YOUR_PROJECTS_TABLE_PAGE,
  SHOW_OLD_PROJECTS,
  SHOW_NEW_PROJECTS,
  INIT_USER_PROJECTS,
  SET_PROJECT_PRODUCT,
  CLEAR_YOUR_PROJECTS_FILTER_DATA,
  SET_FILTER_DATA,
  APPLY_FILTERS,
} from 'actions';
import InputRangeField from 'projectDesign/components/projectConfiguration/components/components/InputRangeField';
import DateRangeField from 'projectDesign/components/projectConfiguration/components/components/DateRangeField';
import { dispatch } from '__common/store';
;
import MultiSelect from 'projectDesign/components/projectConfiguration/components/components/MultiSelect';
import { Dropdown } from 'react-bootstrap';
import _ from 'lodash';
import { getProductTitle } from '__common/constants/products_titles';
import { accessCheckForProduct, getAllowedProductsInfo } from 'app/components/HeaderComponent/utils/getProducts';
import { Search } from '@mui/icons-material';

type yourProjectsTableFilterProps = {
  dispatch: Function;
  yourProjects: yourProjectsState;
  userPreferences: userPreferencesState;
  mfgs: mfg[];
  user: userState;
};

function getDefaultValues() {
  const startDate = new Date();
  startDate.setMonth(startDate.getMonth() - 6);
  const filterSet = {
    project_created_range: { to: new Date(), from: startDate },
    product: [],
    project_wattage_range: { to: 100, from: 0 },
    project_price_range: { to: 5000, from: 50 },
    project_state: [],
    module: [],
  };
  return filterSet;
}

class YourProjectsTableFilter extends React.Component<
  yourProjectsTableFilterProps,
  { filtersOpen: boolean }
> {
  ROWS_PER_PAGE = [10, 20, 50, 100, 200];

  constructor(props: yourProjectsTableFilterProps) {
    super(props);
    this.state = { filtersOpen: false };
    this.updateFilter = debounce(this.updateFilter, 250);
  }

  UNSAFE_componentWillMount() {
    const { dispatch } = this.props;
    dispatch(CHECK_UB1_PROJECTS());
    dispatch(SET_FILTER_DATA(getDefaultValues()));
  }

  @autobind
  clearFilters() {
    const {
      dispatch,
      yourProjects: { rowsPerPage, sortedField, sortMethod, showOldProjects, filterString },
    } = this.props;
    dispatch(APPLY_FILTERS({ application: 'legacy' }));
    dispatch(SET_FILTER_DATA(getDefaultValues()));
    dispatch(SET_YOUR_PROJECTS_PAGINATION_START(0));
    dispatch(
      GET_USER_PROJECTS(rowsPerPage, 0, sortedField, sortMethod, filterString, showOldProjects, { application: 'legacy' }),
    );
    dispatch(SET_YOUR_PROJECTS_TABLE_PAGE(0));
  }

  @autobind
  getUserProjects() {
    const {
      dispatch,
      yourProjects: { rowsPerPage, sortedField, sortMethod, showOldProjects, filterString, filterSet },
    } = this.props;
    const applyFilters = { ..._.cloneDeep(filterSet), application: 'legacy' };
    dispatch(APPLY_FILTERS(applyFilters));
    dispatch(SET_YOUR_PROJECTS_PAGINATION_START(0));
    dispatch(
      GET_USER_PROJECTS(rowsPerPage, 0, sortedField, sortMethod, filterString, showOldProjects, applyFilters),
    );
    dispatch(SET_YOUR_PROJECTS_TABLE_PAGE(0));
    this.setState({ filtersOpen: false });
  }

  @autobind
  updateFilter(filter: string) {
    const {
      dispatch,
      yourProjects: { rowsPerPage, sortedField, sortMethod, showOldProjects, appliedFilters },
    } = this.props;
    dispatch(FILTER_BY_STRING(filter));
    dispatch(SET_YOUR_PROJECTS_PAGINATION_START(0));
    dispatch(
      GET_USER_PROJECTS(rowsPerPage, 0, sortedField, sortMethod, filter, showOldProjects, appliedFilters),
    );
    dispatch(SET_YOUR_PROJECTS_TABLE_PAGE(0));
  }

  @autobind
  changeRowPerPage(rowsPerPage: number) {
    const {
      dispatch,
      yourProjects: { sortedField, sortMethod, filterString, showOldProjects, appliedFilters },
    } = this.props;
    dispatch(SET_ROWS_PER_PAGE(rowsPerPage));
    dispatch(
      GET_USER_PROJECTS(rowsPerPage, 0, sortedField, sortMethod, filterString, showOldProjects, appliedFilters),
    );
    dispatch(SET_YOUR_PROJECTS_TABLE_PAGE(0));
  }

  @autobind
  onFiltersToggle(nextOpen: boolean, meta?: { source?: string; originalEvent?: Event }) {
    if (!nextOpen && meta?.source === 'rootClose') {
      const target = meta.originalEvent?.target as HTMLElement | null;
      if (
        target?.closest?.(
          '[class*="select__menu"], [class*="select__option"], [class*="select__control"], .calendar-popup, .rdp-root',
        )
      ) {
        return;
      }
    }

    this.setState({ filtersOpen: nextOpen });

    if (nextOpen) {
      const {
        dispatch,
        yourProjects: { appliedFilters },
      } = this.props;
      const filterset = _.cloneDeep(appliedFilters);
      if (filterset && Object.keys(filterset).length) {
        dispatch(SET_FILTER_DATA({ ...getDefaultValues(), ...filterset }));
      }
    }
  }


  showOldProjects = (show: boolean) => {
    const { dispatch, userPreferences: { projects_per_page } } = this.props;

    if (show) {
      dispatch(SHOW_OLD_PROJECTS());
    } else {
      dispatch(SHOW_NEW_PROJECTS());
    }

    dispatch(APPLY_FILTERS({ application: 'legacy' }));
    dispatch(INIT_USER_PROJECTS(projects_per_page, show, { application: 'legacy' }));
  }

  renderShowOldProjects = () => {
    const { yourProjects: { gettingOldUbProject, hasOldUb } } = this.props;

    if (hasOldUb && gettingOldUbProject === false) {
      return (
        <span className="show-old-projects">
          <div className="label">SHOW OLD PROJECTS</div>
          {/* <SelectionControl
            id="old-ub"
            type="switch"
            name="lights"
            aria-label="show_old_projects_switch"
            onChange={this.showOldProjects}
          /> */}
          <FormControl
            component="fieldset"
            sx={{ m: 1, width: 'fit-content' }}
          >
            <Checkbox
              checked={hasOldUb}
              onChange={(e) => this.showOldProjects(e.target.checked)}
              name="show_old_projects"
              color="primary"
            />
          </FormControl>
        </span>
      );
    }

    if (hasOldUb === false && gettingOldUbProject) {
      return (
        <span className="show-old-projects">
          <div className="label">Checking if ubuilder 1 projects exist...</div>
        </span>
      );
    }

    if (hasOldUb === false && gettingOldUbProject === false) {
      return (
        <span className="show-old-projects">
          <div className="label">You have no project in ubuilder 1</div>
        </span>
      );
    }
  }

  clearFilterButton() {
    const {
      yourProjects: { appliedFilters },
    } = this.props;
    if (appliedFilters && Object.keys(appliedFilters).length) {
      return (
        <Button className="clearFilters" variant="contained" onClick={this.clearFilters}>
          Clear Filters
        </Button>
      );
    }
  }

  renderFilters() {
    const {
      yourProjects: { filterSet },
      mfgs,
      user,
    } = this.props;
    let mfgOptions = mfgs.map(({ id, name }) => ({ value: id, label: name }));
    mfgOptions = mfgOptions.filter(mfg => mfg.label !== 'All');
    const productOptions = getAllowedProductsInfo(user).map(product => ({ label: product.productLabel, value: product.productId }));
    const states = ['AK', 'AL', 'AR', 'AS', 'AZ', 'CA', 'CO', 'CT', 'DC', 'DE', 'FL', 'GA', 'GU', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY',
      'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MP', 'MS', 'MT', 'NA', 'NC', 'ND', 'NE', 'NH', 'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA',
      'PR', 'RI', 'SC', 'SD', 'TN', 'TX', 'UT', 'VA', 'VI', 'VT', 'WA', 'WI', 'WV', 'WY'];
    const stateOptions = states.map(state => ({ label: state, value: state }));

    return (
      <div className='filterBy'>
        <Dropdown
          show={this.state.filtersOpen}
          onToggle={this.onFiltersToggle}
          autoClose="outside"
        >
          <Dropdown.Toggle className='dropdownToggle'>
            Additional Filters
          </Dropdown.Toggle>
          <Dropdown.Menu
            className="additional-filters-menu"
            onClick={(e: React.MouseEvent) => e.stopPropagation()}
          >

            <div className="filter-input">
              <div className="label">Project Created Range:</div>
              <DateRangeField
                from={filterSet?.project_created_range?.from}
                to={filterSet?.project_created_range?.to}
                onFromChange={(v) => dispatch(SET_PROJECT_CREATED_LOWER_RANGE(v))}
                onToChange={(v) => dispatch(SET_PROJECT_CREATED_UPPER_RANGE(v))}
              />
            </div>
            <Dropdown.Divider />

            <div className="filter-input">
              <div className="label">Project Wattage Range:</div>
              <InputRangeField
                from={filterSet?.project_wattage_range?.from}
                to={filterSet?.project_wattage_range?.to}
                onFromChange={(v) => dispatch(SET_PROJECT_WATTAGE_LOWER_RANGE(v))}
                onToChange={(v) => dispatch(SET_PROJECT_WATTAGE_UPPER_RANGE(v))}
                suffix="kW"
              />
            </div>
            <Dropdown.Divider />

            <div className="filter-input">
              <div className="label">Select Project State:</div>
              <MultiSelect
                options={stateOptions}
                valArray={filterSet?.project_state}
                onChange={(value) => dispatch(SET_PROJECT_STATE(value))}
              />
            </div>
            <Dropdown.Divider />

            <div className="filter-input">
              <div className="label">Select Product:</div>
              <MultiSelect
                options={productOptions}
                valArray={filterSet?.product}
                onChange={(value) => dispatch(SET_PROJECT_PRODUCT(value))}
              />
            </div>
            <Dropdown.Divider />

            <div className="filter-input">
              <div className="label">Select Module Manufacturer:</div>
              <MultiSelect
                options={mfgOptions}
                valArray={filterSet?.module}
                onChange={(value) => dispatch(SET_MODULE(value))}
              />
            </div>
            <Dropdown.Divider />

            <div className="filter-input">
              <div className="label">BOM Price Range:</div>
              <InputRangeField
                from={filterSet?.project_price_range?.from}
                to={filterSet?.project_price_range?.to}
                onFromChange={(v) => dispatch(SET_PROJECT_PRICE_LOWER_RANGE(v))}
                onToChange={(v) => dispatch(SET_PROJECT_PRICE_UPPER_RANGE(v))}
                prefix="$"
              />
            </div>
            <div className="buttons">
              <div className="filter-action-links">
                <Button className='filteBy-buttons resetValues' variant="text" onClick={() => { dispatch(SET_FILTER_DATA(getDefaultValues())); }}>
                  <span className="material-icons">cached</span>
                  Reset Values
                </Button>
                <Button className='filteBy-buttons clearValues' variant="text" onClick={() => { dispatch(CLEAR_YOUR_PROJECTS_FILTER_DATA()); }}>
                  <span className="material-icons">close</span>
                  Clear Values
                </Button>
              </div>
              <button
                type="button"
                className="apply-filters-btn"
                onClick={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  this.getUserProjects();
                }}
              >
                <span className="material-icons">check</span>
                APPLY FILTERS
              </button>
            </div>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    );
  }

  render() {
    const { yourProjects: { rowsPerPage } } = this.props;
    return (
      <div className="your-projects-table-filter">
        <div className='filter-input-fields'>
          <div className="filter-input filterString">
            <div className="label" style={{fontWeight:"100",fontSize:'12px',lineHeight:'12px'}}>FILTER:</div>
            <TextField
              id="filter-input"
              type="text"
              variant="standard"
              size="small"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => this.updateFilter(event.target.value)}
              InputProps={{
                startAdornment: (
                  <Search className="search-icon" />
                ),
              }}
       sx={{
        '& .MuiInputBase-root': {
    height: '0px',
    minHeight:'19px !important'
  },
  '& input': {
    paddingBottom: 0,
    fontSize: '14px',
  },
  '& .MuiInputBase-input': {
    padding: '0 !important',
    boxSizing: 'border-box',

  },
  '& input::placeholder': {
    color: '#777777',
    opacity: 1,
  },
  '& .search-icon': {
    fontSize: '16px',
    marginRight: '0px',
  },
}}
              fullWidth={false}
              error={false}
              placeholder={'enter search text'}
            />
          </div>
          {this.renderShowOldProjects()}
          {this.renderFilters()}
          {this.clearFilterButton()}
        </div>
        <div className='filter-input-fields'>
          <div className="per-page-dropdown">
            <div className="label" style={{fontWeight:"700",fontSize:'11px',lineHeight:'11px',marginTop:'5px'}}>SHOW:</div>
            <RowsPerPage
              rowsPerPage={rowsPerPage}
              rowsPerPageMenu={this.ROWS_PER_PAGE}
              onChange={this.changeRowPerPage}
            />
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(appState: appState) {
  return {
    yourProjects: appState.yourProjects,
    userPreferences: appState.userPreferences,
    mfgs: appState.moduleSelector.mfgs,
    user: appState.user,
  };
}

export default connect(mapStateToProps)(YourProjectsTableFilter);
